import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  signal,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-pin-code',
  imports: [CommonModule],
  templateUrl: './pin-code.component.html',
  styleUrl: './pin-code.component.scss',
})
export class PinCodeComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() disabled = false;

    @Output() pinChanged = new EventEmitter<string>();

    @ViewChild('pinInput') pinInput!: ElementRef<HTMLInputElement>;

    pinValue = signal<string>('');

    private hasViewInitialized = false;

    ngOnChanges(changes: SimpleChanges): void {
      if ('disabled' in changes && !this.disabled && this.hasViewInitialized) {
        this.focusIfEnabled();
      }
    }

    ngOnInit(): void {
      setTimeout(() => {
        this.pinInput.nativeElement.focus();
      });
    }

    ngAfterViewInit(): void {
      this.hasViewInitialized = true;
      this.focusIfEnabled();
    }

    formatPin(event: Event): void {
      const input = event.target as HTMLInputElement;

      let value = input.value.replace(/\D/g, '');
      value = value.slice(0, 4);

      this.pinValue.set(value);
      this.pinChanged.emit(value);
    }

    private focusIfEnabled(): void {
      if (this.pinInput && !this.disabled) {
        setTimeout(() => this.pinInput.nativeElement.focus());
      }
    }
}
